<template>
    <div id="day-list" v-if="Object.keys(allEvents).length === 7">
        <span class="material-icons arrow" @click="prevWeek()">arrow_back_ios_new</span>
        <div v-for="(day, index) in getDays()" class="content">
            <div class="day-info" :class="isToday(day) ? 'today' : ''">
                <div class="day-name">{{ getDayName(day) }}</div>
                <div class="day-number">{{ getDayNumber(day) }}</div>
            </div>
            <div class="events" v-for="event in getEvents(day)">
                <div
                    class="event not-empty"
                    v-if="event !== '-'"
                    @click="isBooked(event) ? createReservationEvent(event, index, day) : ''"
                    :class="isBooked(event) ? 'active' : 'passive'"
                >
                    {{ getTime(event) }}
                </div>
                <div class="event" v-else>{{ "-" }}</div>
            </div>
        </div>
        <span class="material-icons arrow" @click="afterWeek()">arrow_forward_ios</span>
    </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import { mapState } from "vuex";
import { CALENDAR_API, RESERVATION_API } from "../../../../api/calendar";

export default {
    name: "DayList",
    components: {},
    props: {
        data: {
            type: Object,
            required: true,
        },
        reservationDetail: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
        }),
    },
    data() {
        return {
            startDate: "",
            endDate: "",
            allEvents: {},
            busyTimes: [],
            days: [],
            selectedTime: {},
        };
    },
    methods: {
        getSelectedDate(event, index, day) {
            const selectedStartTime = moment(event.start).utc();
            const selectedEndTime = moment(event.end).utc();
            const selectedDate = moment(day).utc();

            const newStart = selectedDate.clone().set({
                hour: selectedStartTime.hour(),
                minute: selectedStartTime.minute(),
                second: selectedStartTime.second(),
                millisecond: selectedStartTime.millisecond(),
            });
            const newEnd = selectedDate.clone().set({
                hour: selectedEndTime.hour(),
                minute: selectedEndTime.minute(),
                second: selectedEndTime.second(),
                millisecond: selectedEndTime.millisecond(),
            });
            this.selectedTime = {
                start: newStart.utc().format(),
                end: newEnd.utc().format(),
            };
        },
        createReservationEvent(event, index, day) {
            this.getSelectedDate(event, index, day);
            const data = {
                selectedTime: this.selectedTime,
                formValues: this.data.formValues,
                userId: this.user._id,
            };
            console.log("createReservationEvent data..", { data });
            RESERVATION_API.createReservationEvent({
                reservationId: this.reservationDetail._id,
                data,
            })
                .then((res) => {
                    console.log("createCalendarEvent res..", { res });
                    this.$message.success("Rezervasyonunuz başarıyla oluşturuldu.");
                })
                .catch((err) => {
                    console.log("createCalendarEvent err..", { err });
                    this.$message.error("Rezervasyon oluşturulurken bir hata oluştu.");
                });
        },
        getTime(event) {
            return `${moment(event.start).format("HH:mm")} - ${moment(event.end).format("HH:mm")}`;
        },
        getEvents(day) {
            if (
                this.reservationDetail.customProgramDates.startDate &&
                this.reservationDetail.customProgramDates.endDate
            ) {
                if (
                    moment(day).add(1, "day").startOf("day").utc().format() >=
                        moment(this.reservationDetail.customProgramDates.startDate).utc().format() &&
                    moment(day).add(1, "day").startOf("day").utc().format() <=
                        moment(this.reservationDetail.customProgramDates.endDate).utc().format()
                ) {
                    const eventLength = Object.keys(this.allEvents);
                    let index = 0;
                    for (let i = 1; i < eventLength.length; i++) {
                        if (moment(this.allEvents[i][0].start).utc().format("L") === moment(day).utc().format("L")) {
                            index = i;
                            break;
                        }
                    }
                    return this.allEvents[index];
                }
            }
        },
        getDate(hours, minutes, day, endDate) {
            //  başlangıç ve bitiş saatine göre günler ayarlanır
            const edate = new Date(endDate).getDay(); // 0 -6
            const a = edate - day;
            let na;
            if (a < 0) na = 7 + a;
            else na = a;
            const date = moment(endDate).subtract(na, "days").utc().format();
            let getDate = new Date(date);
            getDate.setHours(_.toInteger(hours));
            getDate.setMinutes(_.toInteger(minutes));
            return moment(getDate).utc().format();
        },
        separateEvents(start, end) {
            let events = [];
            let startValue = moment(start).utc();
            let endValue = moment(end).utc();
            while (startValue < endValue) {
                let event = {};
                event.start = startValue.format();
                startValue.add(this.reservationDetail.duration, "minutes");
                event.end = startValue.format();
                if (this.busyTimes.length > 0) {
                    const isBusy = this.busyTimes.find((busy) => {
                        const busyStartUTC = moment(busy.start).utc().format("L LT");
                        const eventStartUTC = moment(event.start).utc().format("L LT");
                        return busyStartUTC === eventStartUTC;
                    });
                    if (isBusy) {
                        startValue.add(this.reservationDetail.setting.bufferTimeMinute, "minutes");
                        continue;
                    } else {
                        events = [...events, event];
                    }
                } else {
                    events = [...events, event];
                }
                startValue.add(this.reservationDetail.setting.bufferTimeMinute, "minutes");
            }
            return events;
        },
        setEvents(endDate) {
            this.allEvents = {};
            this.reservationDetail.availability.rules.map((rule) => {
                ["1", "2", "3", "4", "5", "6", "7"].map((weekDay) => {
                    if (!this.allEvents[weekDay]) this.allEvents[weekDay] = [];
                    const days = rule.days[0].split("-");
                    const isInclude = rule.days[0]
                        .split("-")
                        .map((x) => x.toString())
                        .includes(weekDay.toString());
                    if (isInclude) {
                        days.map((day) => {
                            if (day.toString() === weekDay.toString()) {
                                const start = this.getDate(
                                    rule.from.split(":")[0],
                                    rule.from.split(":")[1],
                                    day,
                                    endDate
                                );
                                const end = this.getDate(rule.to.split(":")[0], rule.to.split(":")[1], day, endDate);
                                const events = this.separateEvents(start, end);
                                this.allEvents[weekDay] = [...this.allEvents[weekDay], ...events];
                            }
                        });
                    }
                });
            });
            const lenghts = ["1", "2", "3", "4", "5", "6", "7"].map((weekDay) => {
                return this.allEvents[weekDay].length;
            });
            const maxValue = Math.max(...lenghts);
            ["1", "2", "3", "4", "5", "6", "7"].map((weekDay) => {
                while (this.allEvents[weekDay].length < maxValue) {
                    this.allEvents[weekDay].push("-");
                }
            });
        },
        prevWeek() {
            this.startDate = moment(this.startDate).subtract(2, "days").utc().format();
            this.endDate = moment(this.endDate).subtract(2, "days").utc().format();
        },
        afterWeek() {
            this.startDate = moment(this.startDate).add(2, "days").utc().format();
            this.endDate = moment(this.endDate).add(2, "days").utc().format();
        },
        isToday(day) {
            return moment(day).utc().isSame(moment().utc(), "day");
        },
        getDays() {
            this.days = [];
            let day = this.startDate;
            while (moment(day).utc().isSameOrBefore(this.endDate)) {
                this.days.push(day);
                day = moment(day).utc().add(1, "day").format();
            }
            return this.days;
        },
        getDayName(day) {
            return moment(day).utc().format("dd");
        },
        getDayNumber(day) {
            return moment(day).utc().format("DD");
        },
        isBooked(event) {
            const isMaxReservationCount = this.busyTimes.filter((busy) => {
                const busyStartUTC = moment(busy.start).utc().format("L");
                const eventStartUTC = moment(event.start).utc().format("L");
                return (
                    busyStartUTC === eventStartUTC && busy.reservationId === this.reservationDetail.reservationPlanId
                );
            }).length;

            return (
                moment().add(this.reservationDetail.booking.maxBookingDay, "day").utc() > moment(event.start).utc() &&
                moment().add(this.reservationDetail.booking.minBookingHour, "hour").utc() < moment(event.start).utc() &&
                this.reservationDetail.setting.maxBookingCountPerDay > isMaxReservationCount
            );
        },
        async getAndSetValues(startDate, endDate) {
            const data = {
                calendarIds: [...this.reservationDetail.availabilityCalendarIds, this.reservationDetail.calendarId],
                userId: this.user._id,
                startDate,
                endDate,
            };
            await CALENDAR_API.getCalendarEvents(data).then((res) => {
                console.log("getCalendarEvents res..", { res });
                this.busyTimes = res;
                this.setEvents(endDate);
            });
        },
    },
    async mounted() {
        console.log("reservationDetail..", { reservationDetail: this.reservationDetail });
        this.startDate = moment().utc().format();
        this.endDate = moment().add(1, "days").utc().format();
        this.getAndSetValues(this.startDate, this.endDate);
    },
    watch: {
        endDate(val) {
            this.getAndSetValues(this.startDate, this.endDate);
        },
    },
};
</script>

<style scoped>
#day-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 10px;

    .arrow {
        height: fit-content;
        font-size: 18px;
        border-radius: 50%;
        padding: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgb(95, 99, 104);

        &:hover {
            background-color: #ebebeb;
            cursor: pointer;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 40px;
    }

    .day-info {
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        flex-direction: column;
        margin-bottom: 15px;

        .day-name {
            font-size: 9px;
            text-transform: uppercase;
            margin-bottom: -9px;
        }

        .day-number {
            font-size: 9px;
        }

        &.today {
            background-color: rgb(26, 115, 232);
            border-radius: 50%;
            color: white;
        }
    }

    .events {
        display: flex;
        flex-direction: column;
        align-items: center;

        .event {
            margin: 5px 0;
            font-size: 10px;
            padding: 3px 10px;

            &.not-empty {
                border: 1px solid #e1e1e1;
                border-radius: 3px;

                &.active {
                    cursor: pointer;
                    color: rgb(26, 115, 232);

                    &:hover {
                        background-color: rgb(238 245 255);
                    }
                }

                &.passive {
                    color: grey;
                }
            }
        }
    }
}

@media only screen and (max-width: 630px) {
    #day-list {
        margin: 0;

        .event {
            margin: 5px 2px;
            font-size: 13px;
            padding: 7px 8px !important;
        }
    }
}

@media only screen and (min-width: 630px) and (max-width: 750px) {
    #day-list {
        .event {
            margin: 5px 2px;
            font-size: 13px;
            padding: 6px 11px;
        }
    }
}

@media only screen and (min-width: 750px) and (max-width: 1300px) {
    #day-list {
        .event {
            margin: 5px 0;
            font-size: 13px;
            padding: 5px !important;
        }
    }
}
</style>
